export function handleApiErrorDefault(error: unknown) {
  console.log(error);
}